/**
 * MSW Browser Setup for development/debugging
 */

import { setupWorker } from 'msw/browser';

import { handlers } from './handlers';
import { testModeAuthHandlers } from './handlers/auth-rest';

const useTestAuthMocks = import.meta.env.VITE_TEST_MODE === 'true';

export const worker = setupWorker(
  ...(useTestAuthMocks ? testModeAuthHandlers : []),
  ...handlers,
);
